<template>
  <div>
    <Card shadow>
      <Row :gutter="24">
        <!-- <Col span="7" style="display:none">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">代理组:</span>
            <Select
              v-model="table.params.plat_id"
              filterable
              placeholder="筛选所属分组"
              clearable
              @on-change="updateSelect"
            >
              <Option
                v-for="(item, index) in plat_list"
                :value="item.id"
                :label="item.name"
                :key="`platform_${item.id}_${index}`"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col> -->
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.params.app_id"
              filterable
              placeholder="筛选代理"
              clearable
            >
              <Option
                v-for="(item, index) in app_list.filter(
                  item => item.platform == table.params.platid
                )"
                :value="item.appid"
                :label="item.appName"
                :key="`appid_${item.appid}_${index}`"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="10">
          <label style="display: flex; align-items: center">
            <span style="width: 68px">日期筛选:</span>
            <DatePicker
              type="daterange"
              v-model="select.dataTime"
              placeholder="日期筛选"
              :options="dateOptions"
            ></DatePicker>
          </label>
        </Col>
        <Col span="6">
          <Button type="primary" @click="GetWhiteUidList(1)">查询</Button>
          <Button style="marginLeft: 20px" type="primary" @click="openAddModal"
            >添加风险玩家白名单</Button
          >
        </Col>
      </Row>
    </Card>
    <Table
      ref="table_ref"
      style="margin-top: 10px"
      border
      :columns="table.columns"
      :data="table.data"
      :max-height="tableMaxHeight"
      @on-selection-change="getChangeSelect"
    ></Table>
    <Page
      v-show="table.data.length"
      style="margin-top: 10px"
      :current="table.params.page"
      :total="table.total"
      :page-size-opts="table.pageSizes"
      :page-size="table.params.page_size"
      show-sizer
      show-total
      @on-page-size-change="limitchange"
      @on-change="pagechange"
    ></Page>
    <Row style="margin-top: 12px">
      <Col span="6">
        <Button
          :disabled="table.ids.length == 0"
          type="primary"
          @click="UpdateWhiteUid"
          >批量删除</Button
        >
      </Col>
    </Row>
    <Modal v-model="addModal.show" width="650" @on-cancel="closeAddModal">
      <div slot="header">添加白名单用户</div>
      <Form
        :ref="addModal.ref"
        :model="addModal.params"
        :rules="addModal.rules"
        :label-width="100"
      >
        <Row>
          <Col span="13">
            <FormItem label="所属分组" prop="plat_id">
              <Select
                v-model="addModal.params.plat_id"
                filterable
                placeholder="筛选所属分组"
                @on-change="updateSelect"
              >
                <Option
                  v-for="(item, index) in plat_list"
                  :value="item.id"
                  :label="item.name"
                  :key="`platform_${item.id}_${index}`"
                >
                  {{ item.name }}
                  <span style="color: #bbb">({{ item.id }})</span>
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="13">
            <FormItem label="所属盘口" prop="app_id">
              <Select
                v-model="addModal.params.app_id"
                filterable
                placeholder="筛选代理"
                id="l-data-record-mulsel"
              >
                <Option
                  v-for="(item, index) in app_list.filter(
                    item => item.platform == addModal.params.plat_id
                  )"
                  :value="item.appid"
                  :label="item.appName"
                  :key="`appid_${item.appid}_${index}`"
                >
                  {{ item.appName }}
                  <span style="color: #bbb">({{ item.appid }})</span>
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Col span="18">
          <FormItem label="账户状态">
            <RadioGroup v-model="addModal.type">
              <Radio :label="1">手动输入</Radio>
              <Radio :label="0">上传文件</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Row>
          <Col span="20">
            <FormItem v-if="addModal.type == 1" label="手动输入" prop="uid">
              <Input
                v-model="addModal.params.uid"
                maxlength="1199"
                type="textarea"
                placeholder="输入UID,多次用逗号分隔,单次不超过100个"
                :rows="4"
              />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem v-show="addModal.type == 0" label="上传文件">
              <Upload type="drag" action>
                <div style="padding: 20px 0; width: 65%; float: left">
                  <Icon
                    type="ios-cloud-upload"
                    size="52"
                    style="color: #3399ff"
                  ></Icon>
                  <p style="text-align: center">文件格式：【csv】的文件；</p>
                  <p style="text-align: center">文件大小：不大于1M；</p>
                </div>
                <div style="padding: 20px 0; width: 35%; float: left">
                  <p>上传文件示意图</p>
                  <table
                    border="1"
                    cellpadding="10"
                    cellspacing="0"
                    style="margin-left: 25%; width: 50%"
                  >
                    <tr>
                      <th>uid</th>
                    </tr>
                    <tr>
                      <td>4646</td>
                    </tr>
                    <tr>
                      <td>4646</td>
                    </tr>
                  </table>
                </div>
              </Upload>
              <input
                type="file"
                ref="upload"
                accept=".csv"
                class="outputlist_upload"
              />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="备注:">
              <Input
                v-model="addModal.params.desc"
                maxlength="20"
                placeholder="备注信息，不超过20个字符"
              />
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="warning" @click="closeAddModal">取消</Button>
        <Button type="success" @click="AddWhiteUid()">确认添加</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  GetWhiteUidList,
  AddWhiteUid,
  UpdateWhiteUid
} from '@/api/admin/player'
export default {
  name: 'riskPlayerWhite',
  data() {
    return {
      tableMaxHeight: 0,
      select: {
        dataTime: [this.getCurrentZeroDay(), this.getCurrentZeroDay()]
      },
      table: {
        total: 0,
        pageSizes: [10, 20, 30, 40],
        ids: [],
        params: {
          plat_id: -1,
          app_id: -1,
          page: 1,
          page_size: 10,
          stime: 0,
          etime: 0
        },
        data: [],
        columns: [
          { type: 'selection', width: 60, align: 'center' },
          { title: '序号', type: 'index', width: 100, align: 'center' },
          {
            title: '所属盘口',
            key: 'app_id',
            align: 'center',
            render: (h, params) =>
              h('div', [
                h('span', this.getAppInfo(params.row).appName),
                h(
                  'span',
                  { style: 'color:#bbb;' },
                  '（' + params.row.app_id + '）'
                )
              ])
          },
          { title: '玩家ID', key: 'uid', align: 'center' },
          { title: '添加时间', key: 'ctime', align: 'center' },
          { title: '备注', key: 'desc', align: 'center' }
        ]
      },
      addModal: {
        type: 1,
        show: false,
        ref: 'addModal',
        uidstring: '',
        uidList: [],
        params: { plat_id: 0, app_id: 0, uids: [], desc: '', uid: '' },
        rules: {
          uid: [
            {
              required: true,
              trigger: 'blur',
              validator: this.simpleVerify('请输入')
            }
          ],
          plat_id: [
            {
              required: true,
              trigger: 'change',
              validator: this.simpleVerify('请选择分组')
            }
          ],
          app_id: [
            {
              required: true,
              trigger: 'change',
              validator: this.simpleVerify('请选择盘口')
            }
          ]
        }
      }
    }
  },
  methods: {
    //表单多选
    getChangeSelect(ids) {
      this.table.ids = []
      ids.map(item => {
        this.table.ids.push(item.id)
      })
    },
    //批量删除
    UpdateWhiteUid() {
      this.$Modal.confirm({
        title: '确认删除？',
        onOk: () => {
          UpdateWhiteUid({ ids: this.table.ids }).then(res => {
            // this.$Message.success('批量删除成功');
            this.table.ids = []
            this.GetWhiteUidList()
          })
        }
      })
    },
    //盘口名称匹配
    getAppInfo(el) {
      return this.app_list.find(item => item.appid == el.app_id) || {}
    },

    openAddModal() {
      this.addModal.params = {
        plat_id: 0,
        app_id: 0,
        uids: [],
        desc: '',
        uid: ''
      }
      this.addModal.type = 1
      this.addModal.show = true
    },
    closeAddModal() {
      this.$refs[this.addModal.ref].resetFields()
      this.addModal.show = false
    },
    //分组变化清空盘口选择项
    updateSelect() {
      this.table.params.app_id = -1
    },
    //列表分页
    pagechange(page) {
      this.table.params.page = page
      this.GetWhiteUidList()
    },
    //列表分条
    limitchange(limit) {
      this.table.params.page = 1
      this.table.params.page_size = limit
      this.GetWhiteUidList()
    },
    //添加
    AddWhiteUid(data) {
      this.$refs[this.addModal.ref].validate(valid => {
        if (valid) {
          if (this.addModal.type) {
            let list = this.addModal.params.uid.split(',') || []
            this.addModal.params.uids = []
            list.map(item => {
              this.addModal.params.uids.push(Number(item))
            })
          }

          let params = {
            ...this.addModal.params,
            data: data ? data : ''
          }
          AddWhiteUid(params).then(res => {
            this.closeAddModal()
            this.GetWhiteUidList()
          })
        }
      })
    },
    //请求列表
    GetWhiteUidList(num) {
      if (num) {
        this.table.params.page = 1
      }
      let params = {
        ...this.table.params,
        stime: this.getSecond(this.select.dataTime[0]),
        etime: this.getSecond(this.select.dataTime[1], false)
      }
      GetWhiteUidList(params).then(res => {
        this.table.data = res._param.data || []
        this.table.total = res._param.total
      })
    },
    readExcel(e) {
      //表格导入
      let that = this
      const files = e.target.files
      if (files[0].size > 1024 * 1024 * 1) {
        this.$Message.error('上传文件内容不能大于1M')
        return false
      }
      const fileReader = new FileReader()
      // let nametxt = files[0].name.substring(0,files[0].name.length-4)
      fileReader.onload = ev => {
        try {
          const data = ev.target.result
          this.AddWhiteUid(data)
          this.$refs.upload['value'] = ''
          // const param = {
          //     type: Number(this.modal1.form.data['type']),
          //     tag: this.modal1.form.data['tag'],
          //     platid: this.modal1.form.data['platid'],
          //     data: data,
          //     name: files[0].name,
          // };
          // ExportAccount(param).then((res) => {
          //     this.modal1.show = false;
          //     this.$Message.success('上传文件内容成功');
          //     this.$refs.upload['value'] = '';
          //     this.GetList();
          // });
        } catch (e) {
          return false
        }
      }
      fileReader.readAsText(files[0], 'gb2312')
    }
  },
  created() {
    this.table.params.platid = this.getinitPlatId()
    this.table.params.app_id = this.app_list.find(
      item => item.platform == this.table.params.platid
    ).appid
    this.GetWhiteUidList()
  },
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 280
    this.$refs.upload.addEventListener('change', e => {
      //绑定监听表格导入事件
      this.readExcel(e)
    })
  }
}
</script>
<style lang="less" scoped>
.btn_batch {
  margin-right: 12px;
}
.outputlist_upload {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

/deep/ .ivu-date-picker-rel {
  width: 280px;
}
</style>
